import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useLayoutEffect,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Emty from "../../../components/Emty/Emty";
import UserDetailList from "../../../components/UserDetailList/UserDetailList";
import { ReactComponent as BackSvg } from "./svg/back-arrow.svg";
import {
  ProjectBasicDataType,
  UserCardState,
} from "../../../interface/interface";
import { formatDate } from "../../../lib/lib";
import "./css/index.css";
import { officeApi } from "../../../api/config";
import CsvBtn from "../../../components/CsvBtn/CsvBtn";
interface LocationType {
  state: UserCardState;
}

function UserDetail() {
  const location = useLocation() as LocationType;
  const navigate = useNavigate();
  const rirghtRef = useRef<HTMLDivElement>(null);
  const [userData, setuserData] = useState<UserCardState>({
    login_id: "",
    login_nm: "",
    usr_id: "",
    usr_nm: "",
    usr_email: "",
    cnt_prjt: 0,
    agr_adv: false,
    usr_typ: "TMPL",
    def_reg_at: "",
  });
  const top = [
    { title: "회원번호", data: userData.usr_id },
    { title: "아이디", data: userData.login_id },
    { title: "이메일", data: userData.usr_email },
    { title: "활동명", data: userData.login_nm },
  ];
  const bottom = [
    { title: "등급", data: userData.usr_typ === "TMPL" ? "팀플러" : "팀리더" },
    {
      title: "마케팅동의",
      data: userData.agr_adv ? "동의" : "미동의",
    },
    { title: "미처리신고", data: "미존재" },
    { title: "가입일 ", data: formatDate(Date.now(), "-") },
    { title: "탈퇴일 ", data: "-" },
    { title: "IP ", data: "" },
  ];
  const [nowtype, setnowtype] = useState<string>("project");
  const [data, setData] = useState<ProjectBasicDataType[] | undefined>();
  const __nowtypeChange = useCallback(
    (type: string) => {
      setData(undefined);
      setnowtype(type);
      if (rirghtRef.current) {
        const target = rirghtRef.current;
        target.classList.remove("leftside");
        void target.offsetWidth;
        target.classList.add("leftside");
      }
    },
    [userData]
  );

  const GetCsvData = useCallback((): Promise<any[]> => {
    return new Promise((resolve, reject) => {
      if (nowtype === "project" && data) {
        const change = data.map(
          ({ prjt_type_nm, prjt_nm, rcrt_nm, apprv_sts_nm }) => {
            return [prjt_type_nm, prjt_nm, "-", rcrt_nm, apprv_sts_nm];
          }
        );
        resolve(change);
      }
    });
  }, [nowtype, data]);

  useEffect(() => {
    if (userData) {
      if (nowtype === "project") {
        officeApi
          .get(`/web/my/prjt?usr_id=${userData.usr_id}&row_limit_cnt=10000`)
          .then(({ data: { sts_fg, succ_obj } }) => {
            if (sts_fg) {
              setData(succ_obj.lst);
            }
          });
        // if (project.length > 0) {
        //   setData(project);
        // } else {
        //   setData(undefined);
        // }
      }
      if (nowtype === "coupon") {
        // officeApi.get(`/cstm/cpon_usr`);
        // if (coupon.length > 0) {
        //   setData(coupon);
        // } else {
        //   setData(undefined);
        // }
      }
    }

    return () => {};
  }, [userData, nowtype]);

  useLayoutEffect(() => {
    officeApi
      .get(`/auth/usr/usr/${location.state.usr_id}`)
      .then(({ data: { sts_fg, succ_obj } }) => {
        if (sts_fg) {
          setuserData(succ_obj.info);
        }
      });
    return () => {};
  }, [location]);

  return (
    <main className="user-detail">
      <div className="wrapper">
        <div className="title-wrapper">
          <BackSvg
            onClick={() => {
              navigate(-1);
            }}
          />
          <div className="title">회원 상세</div>
        </div>
        <div className="content">
          <div className="left">
            <div className="box">
              <div className="title">기본 정보</div>
              <div className="top">
                {top.map(({ title, data }, idx) => {
                  return (
                    <div className="info" key={idx}>
                      <div className="title">{title}</div>
                      <div
                        className="content"
                        style={
                          idx === 1
                            ? {
                                fontWeight: 700,
                              }
                            : undefined
                        }
                      >
                        {data}
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="line" />
              <div className="bottom">
                {bottom.map(({ title, data }, idx) => {
                  return (
                    <div className="info" key={idx}>
                      <div className="title">{title}</div>
                      <div className="content">{data}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="state-box">
              {statearr.map(({ title, type }, idx) => {
                return (
                  <button
                    key={idx}
                    className={`state-btn ${
                      type === nowtype ? "active-btn" : ""
                    }`}
                    onClick={() => {
                      __nowtypeChange(type);
                    }}
                  >
                    {title}
                  </button>
                );
              })}
            </div>
          </div>
          <div className="right" ref={rirghtRef}>
            <div className="title-wrapper">
              <div className="left">
                <img src="/assets/common/plus.svg" alt="" />
                <div className="title">
                  {nowtype === "project"
                    ? "참여 프로젝트 목록"
                    : nowtype === "coupon"
                    ? "발급 인비테이션 쿠폰"
                    : "신고 접수"}
                </div>
              </div>
              {userData && (
                <CsvBtn
                  title={`${userData.login_nm}님 참여 프로젝트 목록`}
                  headers={projectTag.map((item) => item.title)}
                  getCsvData={GetCsvData}
                />
              )}
            </div>
            {data ? (
              <UserDetailList
                type={nowtype}
                tagarr={
                  nowtype === "project"
                    ? projectTag
                    : nowtype === "coupon"
                    ? couponTag
                    : reportTag
                }
                data={data}
              />
            ) : (
              <Emty />
            )}
          </div>
        </div>
      </div>
    </main>
  );
}

export default UserDetail;

const statearr = [
  {
    title: "참여 프로젝트 목록",
    type: "project",
  },
  {
    title: "발급 인비테이션 쿠폰",
    type: "coupon",
  },
  // {
  //   title: "신고 접수",
  //   type: "report",
  // },
];

const projectTag = [
  { title: "유형", type: "category" },
  { title: "프로젝트명", type: "name" },
  { title: "신청일", type: "timestamp" },
  { title: "신청직무", type: "payment" },
  { title: "선정여부", type: "price" },
];

const couponTag = [
  { title: "항목", type: "coupon-name" },
  { title: "사용기한", type: "period" },
  { title: "발행인", type: "admin" },
  { title: "사용여부", type: "use" },
];

const reportTag = [
  { title: "신고인 계정", type: "reporter" },
  { title: "신고접수 일시", type: "report-time" },
  { title: "차단", type: "disable" },
];
